import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';

export const Buttons = ({ name, onChange, isActive, inStock }) => {
  const showInStock = inStock || typeof inStock === 'undefined';

  const styles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px',
    height: '40px',
    paddingVertical: '0',
    paddingHorizontal: 'xsmall',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: isActive ? 'lowContrast' : 'ultraLowContrast',
    color: 'ultraLowContrast',
    cursor: 'pointer',
    marginRight: 'xsmall',
    marginBottom: 'xsmall',
    background: showInStock
      ? 'section'
      : 'linear-gradient(to left top, transparent 47.75%, currentColor 49.5%, currentColor 50.5%, transparent 52.25%)'
  };

  return (
    <UX2.Element.Block style={ styles } onClick={ () => onChange(name) }>
      <UX2.Element.Details disabled={ !isActive } featured={ isActive }>
        { name }
      </UX2.Element.Details>
    </UX2.Element.Block>
  );
};

Buttons.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  isActive: PropTypes.bool,
  inStock: PropTypes.bool
};

export default Buttons;
